import { render, staticRenderFns } from "./CustomFieldDetails.vue?vue&type=template&id=2a880d5c"
import script from "./CustomFieldDetails.vue?vue&type=script&lang=js"
export * from "./CustomFieldDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports